import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import GuidesTab from "../../atoms/GuidesTab";
import { colors, header } from "../../../styles/variables";
import urlPatterns from "../../../urls";
import { checkScrollingDown } from "../../../helpers/tools";
import { StyledHeaderTabs, TabBarContainer, StyledContainer, GuidesTabBar, GuidesTabRef } from "./style";

class GuidesTabNavigator extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showHeaderBarFromChild: true,
    };
    this.previousScrollY = 0;
  }

  componentDidMount() {
    const element = this.horizontalContainer;
    const { clientWidth, scrollWidth } = element || {};
    const { url101, urlGrapeType, urlRegion, urlTasting, urlMore } = this.props;

    // CASE: When GuidesTabBar is scrollable
    if (clientWidth < scrollWidth && this.horizontalContainer) {
      let el = this.wine101;
      if (url101) {
        this.horizontalContainer.scrollTo({ left: 0 });
      } else {
        if (urlGrapeType) {
          el = this.grapes;
        }
        if (urlRegion) {
          el = this.region;
        }
        if (urlTasting) {
          el = this.tasting;
        }
        if (urlMore) {
          el = this.more;
        }
        this.horizontalContainer.scrollTo({ left: el && el.offsetLeft - 50 });
      }
    }

    return window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    return window.removeEventListener("scroll", this.handleScroll);
  }

  /**
   * Handler for scroll event listeners,
   * ...to set state to show or hide Header bar.
   * */
  handleScroll = () => {
    const { isScrollingDown, yValue } = checkScrollingDown(this.previousScrollY);
    this.previousScrollY = yValue;
    const { showHeaderBarFromChild } = this.state;
    if (showHeaderBarFromChild === isScrollingDown) {
      // CASE: If scrolling down, hides header if shown
      // and, if scrolling up, shows header if hidden.
      this.setState({ showHeaderBarFromChild: !isScrollingDown });
    }
  };

  getFormattedTabLink = (url) => {
    const { location } = this.props;
    const { search } = location || {};
    return {
      pathname: url,
      search,
    };
  };

  render() {
    const {
      headerStyleTop,
      mobileHeaderStyleTop,
      shouldDisappearOnMobile,
      backgroundColor,
      url101,
      urlGrapeType,
      urlRegion,
      urlTasting,
      urlMore,
    } = this.props;

    const { showHeaderBarFromChild } = this.state;
    return (
      <>
        <StyledHeaderTabs
          top={headerStyleTop}
          shouldDisappearOnMobile={shouldDisappearOnMobile}
          mobileTop={mobileHeaderStyleTop}
          backgroundColor={backgroundColor}
          isHeaderShown={showHeaderBarFromChild}
        >
          <StyledContainer>
            <TabBarContainer>
              <GuidesTabBar
                bgColor={backgroundColor || colors.peach}
                isHorizontalScrollable
                ref={(domObj) => {
                  this.horizontalContainer = domObj;
                }}
              >
                <GuidesTabRef
                  ref={(domObj) => {
                    this.wine101 = domObj;
                  }}
                >
                  <GuidesTab to={this.getFormattedTabLink(urlPatterns.GUIDE_101)} isActive={!!url101}>
                    {"Wine 101 Guides"}
                  </GuidesTab>
                </GuidesTabRef>
                <GuidesTabRef
                  ref={(domObj) => {
                    this.grapes = domObj;
                  }}
                >
                  <GuidesTab
                    to={this.getFormattedTabLink(urlPatterns.GUIDE_GRAPE_COLOR)}
                    isActive={!!urlGrapeType}
                  >
                    {"Grape Varieties"}
                  </GuidesTab>
                </GuidesTabRef>
                <GuidesTabRef
                  ref={(domObj) => {
                    this.region = domObj;
                  }}
                >
                  <GuidesTab to={this.getFormattedTabLink(urlPatterns.GUIDE_REGION)} isActive={!!urlRegion}>
                    {"Region Guides"}
                  </GuidesTab>
                </GuidesTabRef>
                <GuidesTabRef
                  ref={(domObj) => {
                    this.tasting = domObj;
                  }}
                >
                  <GuidesTab to={this.getFormattedTabLink(urlPatterns.GUIDE_TASTING)} isActive={!!urlTasting}>
                    {"Tasting Guides"}
                  </GuidesTab>
                </GuidesTabRef>
                <GuidesTabRef
                  ref={(domObj) => {
                    this.more = domObj;
                  }}
                >
                  <GuidesTab to={this.getFormattedTabLink(urlPatterns.GUIDE_MORE)} isActive={!!urlMore}>
                    {"Food & Wine"}
                  </GuidesTab>
                </GuidesTabRef>
              </GuidesTabBar>
            </TabBarContainer>
          </StyledContainer>
        </StyledHeaderTabs>
      </>
    );
  }
}

GuidesTabNavigator.propTypes = {
  headerStyleTop: PropTypes.string,
  mobileHeaderStyleTop: PropTypes.string,
  shouldDisappearOnMobile: PropTypes.bool,
  backgroundColor: PropTypes.string.isRequired,
  url101: PropTypes.string,
  urlGrapeType: PropTypes.string,
  urlRegion: PropTypes.string,
  urlTasting: PropTypes.string,
  urlMore: PropTypes.string,
  location: PropTypes.shape({}).isRequired,
};

GuidesTabNavigator.defaultProps = {
  headerStyleTop: header.desktopHeight,
  mobileHeaderStyleTop: null,
  shouldDisappearOnMobile: false,
  url101: null,
  urlGrapeType: null,
  urlRegion: null,
  urlTasting: null,
  urlMore: null,
};

export default GuidesTabNavigator;
